import React from 'react';
import { SchemaComponent } from '../Schemas/Schema';
import { bemClasses } from '../../helpers';
import { LOCATION_TEXT } from '../../constants';
export var Parameter = function (_a) {
    var _b = _a.param, description = _b.description, location = _b.location, schema = _b.schema, _c = _a.name, name = _c === void 0 ? '' : _c;
    return (React.createElement("div", { className: bemClasses.element("channel-parameter") },
        React.createElement("header", { className: bemClasses.element("channel-parameter-header") }, location && (React.createElement("h4", null,
            LOCATION_TEXT,
            ": ",
            location))),
        React.createElement("div", { className: bemClasses.element("channel-parameter-schema") },
            React.createElement(SchemaComponent, { name: name, schema: schema, hideTitle: true, description: description }))));
};
//# sourceMappingURL=Parameter.js.map